module.exports = __webpack_public_path__ + "img/carhub.01e02f8c.jpg";